import React from "react";
import classnames from "classnames";
import { usePagination, DOTS } from "./usePagination";
import { PaginationItem, PaginationLink } from "reactstrap";
//import "./pagination.scss";
const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <ul
      className={classnames("pagination-container mb-0", {
        [className]: className,
      })}
    >
      <PaginationItem
        className={classnames("page-item", {
          disabled: currentPage === 1,
        })}
      >
        <PaginationLink onClick={onPrevious} to="#">
          ← &nbsp; Prev
        </PaginationLink>
      </PaginationItem>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <PaginationItem className="page-item dots" key={index}>
              <PaginationLink to="#"> &#8230; </PaginationLink>
            </PaginationItem>
          );
        }

        return (
          <PaginationItem
            className={classnames("page-item", {
              active: pageNumber === currentPage,
            })}
            key={index}
          >
            <PaginationLink onClick={() => onPageChange(pageNumber)} to="#">
              {pageNumber}
            </PaginationLink>
          </PaginationItem>
        );
      })}

      <PaginationItem
        className={classnames("page-item", {
          disabled: currentPage === lastPage,
        })}
      >
        <PaginationLink onClick={onNext} to="#">
          Next &nbsp; →
        </PaginationLink>
      </PaginationItem>
    </ul>
  );
};

export { Pagination };
